// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3342":"css/app.7038","8162":"css/admin-app.7038"}[chunkId] + ".css";
};